import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listaPendientesAutorizar } from "../../utils/Datos";
import { PlaceholderTabla } from "../Otros/Placeholder";

export const PendientesAutorizar = () => {
  const [updateProceso, setUpdateProceso] = useState(true);
  const [datos, setDatos] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  let navigate = useNavigate();

  useEffect(() => {
    if (updateProceso === true && cargandoDatos === false) {
      listaPendientesAutorizar().then((datos) => {
        setCargandoDatos(false);
        setDatos(datos);
        console.log("setDatso");
        console.log(datos);
        setUpdateProceso(false);
      });
    }
  }, []);

  const handleClick = (id_participant, id_precalifiacion) => {
    const url = `/autorizarPrecalificacion/${id_participant}/${id_precalifiacion}`;
    navigate(url, {});
  };

  return datos == null || cargandoDatos || updateProceso ? (
    <PlaceholderTabla></PlaceholderTabla>
  ) : (
    <div className="table-responsive">
      <table className="table table-rounded table-striped border gy-7 gs-7">
        <thead>
          <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
            <th>Etapa</th>
            <th>Rut</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Unidad</th>
            <th>Precalificar</th>
            <th>Autorizar</th>
          </tr>
        </thead>
        <tbody>
          {datos.status === true && datos.datos.length > 0 ? (
            datos.datos.map((dato) => {
              return (
                <tr key={dato.rutOfficier}>
                  <td>{dato.nameStage}</td>
                  <td>{dato.rutOfficer}</td>
                  <td>{dato.nameOfficer}</td>
                  <td>{dato.nameMunicipalDirection}</td>
                  <td>{dato.nameMunicipalUnit}</td>
                  <td>DATO PENDIENTE</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                      onClick={() =>
                        handleClick(
                          dato.id_participant,
                          dato.id_preQualifications
                        )
                      }
                    >
                       Autorizar
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={7}>No hay datos para mostrar</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
